import App from './App.svelte';
import wasm from './core/Cargo.toml';

const init = async() => {
	const wasm_core = await wasm();

	const app = new App({
		target: document.getElementById("clipivot-entry"),
		props: {
			clipivot_core: wasm_core
		}
	});
};

init();